<template>
    <div id="description-mongolia-05">
        <div class="header">
            <div class="arrow-down text-center">
                <img :src="arrowDown" alt="arrowDown" @click="clickScroll">
            </div>
        </div>

        <p id="title-description" class="title-description">
            Did you know<br/>
            <span class="text-color">Mongolia</span> has<br/> 
            <span class="text-color">a horseracing</span> <br/>
            <span class="text-color">festival</span>?
        </p>

        <div class="description">
            <p>As part of our nomadic culture, most people learn to ride a horse at a young age. To celebrate cultural heritage, each year an exciting but challenging horse race festival is prepared. Without a doubt, jockeys and horses go through intense training leading up to the event.</p>
            <p>It is one of three games that take place during the Naadam festival. Other games are wrestling and archery. </p>
            <p>Typically held from July 11 – 15, Naadam festival brings together communities and villages. However, some villages prefer to do it on their own at another time. So, if you miss it during July, there’s always another chance to see it in another part of the country. </p>
            <p>Naadam festival is more than just a sporting event, it’s considered our national holiday. So, come – travel to Mongolia and experience this exciting festival for yourself.</p>
        </div>
        <IG />
        <div class="arrow">
            <div class="text-left">
                <router-link to="/description-mongolia-04">
                    <img :src="arrowLeft" alt="arrowLeft">
                </router-link>
            </div>
            <div class="text-right">
                <router-link to="/description-mongolia-06">
                    <img :src="arrowRight" alt="arrowRight">
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import arrowDown from '../../assets/img/arrow-down.png'
import arrowLeft from '../../assets/img/arrow-left.png'
import arrowRight from '../../assets/img/arrow-right.png'
import IG from '@/components/FirstIG'
import { TweenLite } from "gsap/all"

export default {
    name: 'description-mongolia-05',
    components: {
        IG
    },
    data() {
        return {
            arrowDown: arrowDown,
            arrowLeft : arrowLeft,
            arrowRight : arrowRight
        }
    },
    methods: {
        clickScroll() {
            TweenLite.to(window, .6, {scrollTo:{y:"#title-description", offsetY:60}});
        }
    }
}
</script>

<style lang="scss" scoped>
    #description-mongolia-05 {
        .header {
            height: 370px;
            background-image: url('../../assets/img/bg-description-05.png');
            background-size: cover;
            background-repeat: no-repeat;
            position: relative;

            .arrow-down {
                position: absolute;
                bottom: 17px;
                width: 100%;
            }
        }

        .title-description {
            color: #2C2C2C;
            font-size: 30px;
            font-weight: bold;
            padding:0px 20px;
            margin: 30px 0px;
        }

        .text-color {
            color: #E31F25;
        }

        .description {
            padding:0px 20px;
        }

        .arrow {
            display: flex;
            padding: 60px 0 30px;
            div {
                width: 50%;
            }
        }
    }
</style>


